import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";

const PAGES = [
  { key: "home", label: "Homepage" },
  { key: "about", label: "About Us" },
  { key: "contact", label: "Contact" },
  { key: "privacy", label: "Privacy" },
  { key: "terms", label: "Terms" },
  { key: "refund", label: "Refund & Cancellation" },
  { key: "shipping", label: "Shipping & Delivery" },
  { key: "digital-delivery", label: "Digital Delivery" },
  { key: "disclaimer", label: "Disclaimer" },
  { key: "grievance", label: "Grievance & Support" },
];

function JsonEditor({ pageKey }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    setLoading(true);
    api.get(`/admin/content/${pageKey}`).then(({ data }) => {
      const { key, _id, ...rest } = data || {};
      setText(JSON.stringify(rest, null, 2));
    }).finally(() => setLoading(false));
  }, [pageKey]);
  const save = async () => {
    let parsed;
    try { parsed = JSON.parse(text); } catch { return toast.error("Invalid JSON"); }
    setSaving(true);
    try { await api.put(`/admin/content/${pageKey}`, parsed); toast.success("Content saved"); }
    catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };
  if (loading) return <Loader2 className="w-6 h-6 animate-spin text-teal" />;
  return (
    <div>
      <p className="text-xs text-slate-400 mb-2">Edit page content as structured JSON. Change text, headlines, FAQ, sections — no code needed.</p>
      <Textarea rows={20} className="bg-slate-950 border-white/10 text-slate-200 font-mono text-xs" value={text} onChange={(e) => setText(e.target.value)} data-testid={`content-json-${pageKey}`} />
      <Button className="mt-3 bg-teal hover:bg-teal-dark text-white" onClick={save} disabled={saving} data-testid={`content-save-${pageKey}`}>{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save content"}</Button>
    </div>
  );
}

export default function AdminContent() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Content & CMS</h1>
      <Tabs defaultValue="home">
        <TabsList className="bg-slate-800 flex-wrap h-auto">
          {PAGES.map((p) => <TabsTrigger key={p.key} value={p.key} data-testid={`content-tab-${p.key}`}>{p.label}</TabsTrigger>)}
        </TabsList>
        {PAGES.map((p) => <TabsContent key={p.key} value={p.key} className="mt-4"><JsonEditor pageKey={p.key} /></TabsContent>)}
      </Tabs>
    </div>
  );
}
